import { Button } from 'antd';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../assets/Images/icons/icon-back';
import ModalConfirm from '../../components/Shared/modal/confirm';
import ModalDiscardChanges from '../../components/Shared/modal/discardChanges';
import XflowComponent from '../../components/xflow';
import { ROUTER } from '../../constants/router';
import useNotify from '../../context/Notification/useNotify';
import DataFlowService from '../../services/DataFlow.service';
import { useBlocker } from '../../util/usePrompt';

const EditFlow = () => {
    const { businessProcessId } = useParams();
    const { t } = useTranslation();
    let navigate = useNavigate();
    const [detail, setDetail] = useState();

    const notify = useNotify();
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    const btnRef = useRef(null);

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const updateIsGenerateDataFlow = async (isGenerateDataFlow) => {
        try {
            await DataFlowService.updateIsGenerateDataFlow({
                businessProcessId,
                isGenerateDataFlow,
            });
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };

    const onSave = async () => {
        let payload = {
            businessProcessId: businessProcessId,
            jsonData: JSON.stringify(valueSave),
        };
        try {
            const { data } = await DataFlowService.updateTab6(payload);
            if (data?.resultCode === 1) {
                setChange(3);
                setOpenChange(false);
                setChange(false);
                setLoading(false);
                updateIsGenerateDataFlow(false);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to submitted'),
                });
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setOpenConfirm(false);
        }
    };

    useEffect(() => {
        if (change === 3) {
            changePage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [change]);

    const changePage = () => {
        navigate(
            `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=8&refresh=1`
        );
    };

    const [graphData, setGraphData] = useState();

    useEffect(() => {
        if (detail?.dataDiagram?.jsonData) {
            setGraphData(JSON.parse(detail?.dataDiagram?.jsonData));
        } else {
            setGraphData({ nodes: [], edges: [] });
        }
    }, [detail?.dataDiagram?.jsonData]);

    useEffect(() => {
        const getDataFlowDetail = async () => {
            try {
                const { data } = await DataFlowService.getDataFlowDetail(
                    businessProcessId
                );
                if (data?.resultData) {
                    setDetail(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getDataFlowDetail();
    }, [businessProcessId]);

    return (
        <div>
            <div className="title flex">
                <button
                    type="button"
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(
                            `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=8`
                        );
                    }}
                >
                    <IconBack />
                </button>
                {t('Edit Data Flow')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Inventory')} / {t('Data Flow')} /{' '}
                </span>
                <span>{t('Edit Data Flow')}</span>
            </div>
            <div
                onClick={() => {
                    setChange(true);
                }}
            >
                <div className="flex space-x-4 justify-end mt-3.5 mb-6">
                    <Button
                        className="w-[121px]"
                        type="default"
                        size="large"
                        onClick={changePage}
                    >
                        {t('common.Cancel')}
                    </Button>
                    <Button
                        ref={btnRef}
                        hidden={true}
                        className="w-[121px]"
                        size="large"
                        type="primary"
                        htmlType="submit"
                        onClick={() => {
                            setOpenConfirm(true);
                        }}
                    >
                        {t('common.Save')}
                    </Button>
                </div>
                {graphData && (
                    <XflowComponent
                        graphData={graphData}
                        btnRef={btnRef}
                        setValueSave={setValueSave}
                    />
                )}
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSave}
                handelClose={() => setOpenConfirm(false)}
            />
        </div>
    );
};

export default EditFlow;
